import * as React from 'react';
import { Props } from 'react';

import './HomeView.scss';
import i18next from 'i18next';

const telemedicine = {
    photo: require('../../../assets/telemedicine_photo.png'),
    logo: require('../../../assets/telemedicine_logo.svg'),
    partner_link: 'https://www.medipol.com.tr/en/contact-us/make-an-appointment'
};

interface HomeViewProps extends Props<HomeView> {
    channelId: string;
}

export class HomeView extends React.Component<HomeViewProps> {
    render() {
        /*const {channelId} = this.props;*/
        return (
            <div className='telemedicine-container'>
                <div
                    className='telemedicine-container__photo'
                >
                    <img src={telemedicine.photo}/>
                </div>
                <div className='telemedicine-container__description'>
                        <pre className='telemedicine-container__description__content'>
                            {i18next.t('telemedicine_info')}
                        </pre>
                    <div dangerouslySetInnerHTML={{ __html: i18next.t('telemedicine_appointment')}} />
                    <div dangerouslySetInnerHTML={{ __html: i18next.t('telemedicine_phone')}} />
                    <img src={telemedicine.logo}/>
                </div>
                <a href={telemedicine.partner_link}>
                    <div className='footer-button__wrapper'>
                        <div className='button purple big center'>{i18next.t('fill_out_a_questionnaire')}</div>
                    </div>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Telemedicine/Home/HomeView.tsx